module.exports = __webpack_public_path__ + "static/media/download macOS.b36bcf72.svg";